export const PENDING_TRANSACTION = 'There is a pending transaction'
export const CONFIGURATION_SELLER = 'No hay configuración para este vendedor.'
